import ProgressDots from './ProgressDots';

const Progress = {
  Dots: ProgressDots,
};

export default Progress;
